import { Linking, View } from "react-native";
import { VERSION, globalAny } from "../../utils/Utils";
import LabelContainer from "../../components/SettingsComponent/labelContainer";
import SettingsContainer from "../../components/Layout/SettingsContainer";
import External from "../../assets/Icons/External.svg";

const SettingsHelpAndAbout = () => {
	const helpAndAboutStyles = { paddingTop: 30, marginBottom: "5%" };

	return (
		<View style={helpAndAboutStyles}>
			<SettingsContainer>
				<LabelContainer header={globalAny.language.ridevue_version + VERSION} body={"Sony Pictures"} />
				<LabelContainer
					header={globalAny.language.for_faq}
					subHeader={""}
					onPressSubHeader={() => Linking.openURL("")}
					isIcon={true}
					disableIcon={true}
					imageSource={External}
					onClickableBody={false}
				/>
				<LabelContainer
					header={globalAny.language.problem_exp}
					subHeader={""}
					onPressSubHeader={() => Linking.openURL("")}
					isIcon={true}
					disableIcon={true}
					imageSource={External}
					onClickableBody={false}
				/>
				<LabelContainer
					header={globalAny.language.sony_acknowledge}
					body={globalAny.language.help_and_about_body}
					footer={"http://www.geoffdifford.com/computers/wsa.html"}
					onPressFooter={() => Linking.openURL("http://www.geoffdifford.com/computers/wsa.html")}
					onClickableFooter={false}
					isFooterIcon={true}
				/>
			</SettingsContainer>
		</View>
	);
};

export default SettingsHelpAndAbout;
